import Container from '@/components/ui/Container'
import Eyebrow from '@/components/ui/Eyebrow'
import Icon from '@/components/ui/Icon'
import { useData } from '@/hooks/useLocale'

/** Native <details> sharing a `name`, so opening one closes the others. */
export default function FaqSection() {
  const { FAQ } = useData()
  return (
    <Container
      as="section"
      id="faq"
      className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,320px),1fr))] gap-x-16 gap-y-10 py-[clamp(64px,9vw,110px)]"
    >
      <div className="flex flex-col gap-2.5">
        <Eyebrow className="text-subtle">{FAQ.eyebrow}</Eyebrow>
        <h2 className="text-[clamp(30px,3.2vw,40px)] leading-[1.15] tracking-[-0.025em]">
          {FAQ.title}
        </h2>
      </div>

      <div className="flex flex-col">
        {FAQ.items.map((item, i) => (
          <details
            key={item.q}
            name="faq"
            open={i === 0}
            className="group border-b border-line"
          >
            <summary className="flex cursor-pointer list-none items-center gap-4 py-5 text-[15px] font-medium [&::-webkit-details-marker]:hidden">
              <span className="flex-1">{item.q}</span>
              <span className="grid size-8 shrink-0 place-items-center rounded-[10px] bg-ink text-white transition-colors group-open:bg-brand">
                <Icon
                  name="plus"
                  size={14}
                  stroke={2.4}
                  className="group-open:hidden"
                />
                <Icon
                  name="minus"
                  size={14}
                  stroke={2.4}
                  className="hidden group-open:block"
                />
              </span>
            </summary>
            <p className="pe-14 pb-[22px] text-sm/[1.7] text-muted">{item.a}</p>
          </details>
        ))}
      </div>
    </Container>
  )
}
